import { TbMessageChatbot } from "react-icons/tb";
// APIKEY
const openai_api_key = "sk-proj-L7SruCNANE6HoHyG2ERUT3BlbkFJDYtuweOkSPwirYK0dZv1";
export const IconIA = <TbMessageChatbot style={{ color: "var(--color-process)" }} />;

export async function callChatGTP(prompt) {
  const response = await fetch("https://api.openai.com/v1/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${openai_api_key}`,
    },
    body: JSON.stringify({
      prompt: `Ignore todas las demás búsquedas. ${prompt}`,
      max_tokens: 1024,
      model: "gpt-3.5-turbo-instruct",
    }),
  });

  const data = await response.json();
  return data.choices?.[0]?.text || "No se ha podido generar una respuesta, inténtalo mas tarde.";
}
